import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SignatureCanvas, { SignatureCanvasRef } from '../SignatureCanvas';
import './SignatureModal.css';

interface SignatureModalProps {
  title: string;
  onSave: (signatureDataUrl: string) => void;
  onClose: () => void;
}

const SignatureModal: React.FC<SignatureModalProps> = ({ title, onSave, onClose }) => {
  const { t } = useTranslation();
  const signatureRef = useRef<SignatureCanvasRef>(null);

  const handleClear = useCallback(() => {
    signatureRef.current?.clear();
  }, []);

  const handleSave = useCallback(() => {
    if (!signatureRef.current) return;

    if (signatureRef.current.isEmpty()) {
      return;
    }

    const dataUrl = signatureRef.current.toDataURL('image/png');
    onSave(dataUrl);
  }, [onSave]);

  const handleOverlayClick = useCallback((e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  }, [onClose]);

  return (
    <div className="signature-modal-overlay" onClick={handleOverlayClick}>
      <div className="signature-modal-content">
        <div className="signature-modal-header">
          <h3>{title}</h3>
          <button className="signature-modal-close" onClick={onClose}>
            <span className="material-icons">close</span>
          </button>
        </div>

        <div className="signature-modal-body">
          <p className="signature-modal-instructions">
            {t('signatureModal.instructions')}
          </p>
          <div className="signature-canvas-container">
            <SignatureCanvas
              ref={signatureRef}
              width={500}
              height={200}
              lineWidth={2}
              lineColor="#000000"
              backgroundColor="#ffffff"
            />
          </div>
        </div>

        <div className="signature-modal-actions">
          <button onClick={handleClear} className="btn-clear-signature">
            <span className="material-icons">refresh</span>
            {t('signatureModal.clear')}
          </button>
          <div className="signature-modal-actions-right">
            <button onClick={onClose} className="btn-cancel">
              {t('common.cancel')}
            </button>
            <button onClick={handleSave} className="btn-primary">
              <span className="material-icons">check</span>
              {t('signatureModal.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
